import { cloneDeep, isString } from 'lodash';
import { getTrackConfig, IFramework } from '@/framework';
import { getLayerInfoWithRotate } from '@/utils/layer-kit';
import { ILayerInfo, ILayerProps, IPoint } from '@/version-types';

export class CanvasAlign {
    constructor(private framework: IFramework) {}

    private updateChildrenLayer(layer: ILayerProps, offsetLeft = 0, offsetTop = 0) {
        (layer.children || []).forEach((item) => {
            item.left = item.left + offsetLeft;
            item.top = item.top + offsetTop;
            this.updateChildrenLayer(item, offsetLeft, offsetTop);
        });
    }

    private updateLayer(id: string, align: string, callback: (info: ILayerInfo) => IPoint) {
        const oldLayer = this.framework.getLayer(id, true);
        const newLayer = cloneDeep(oldLayer);
        const layerInfo = getLayerInfoWithRotate(newLayer);
        const { x, y } = callback(layerInfo);
        newLayer.left += x;
        newLayer.top += y;
        this.updateChildrenLayer(newLayer, x, y);
        this.framework.stage.addOrUpdate(newLayer);
        this.framework.operate.setActiveLayer(id);
        const config = getTrackConfig(this.framework.identity, newLayer);
        const trackFunc = config?.align?.[align] || (isString(config?.align) ? config?.align : undefined);
        this.framework.history.write(oldLayer, trackFunc);
    }

    /**
     * 左对齐
     */
    left(id: string) {
        this.updateLayer(id, 'left', (info) => {
            return {
                x: -info.left,
                y: 0,
            };
        });
    }

    /**
     * 水平居中
     */
    horizontalCenter(id: string) {
        const { width: canvasWidth } = this.framework.stage.getActiveStageSize();
        this.updateLayer(id, 'horizontalCenter', (info) => {
            return {
                x: ~~(canvasWidth - info.width) / 2 - info.left,
                y: 0,
            };
        });
    }

    /**
     * 右对齐
     */
    right(id: string) {
        const { width: canvasWidth } = this.framework.stage.getActiveStageSize();
        this.updateLayer(id, 'right', (info) => {
            return {
                x: canvasWidth - info.width - info.left,
                y: 0,
            };
        });
    }

    /**
     * 顶部对齐
     */
    top(id: string) {
        this.updateLayer(id, 'top', (info) => {
            return {
                x: 0,
                y: -info.top,
            };
        });
    }

    /**
     * 垂直居中
     */
    verticalCenter(id: string) {
        const { height: canvasHeight } = this.framework.stage.getActiveStageSize();
        this.updateLayer(id, 'verticalCenter', (info) => {
            return {
                x: 0,
                y: ~~(canvasHeight - info.height) / 2 - info.top,
            };
        });
    }

    /**
     * 底部对齐
     */
    bottom(id: string) {
        const { height: canvasHeight } = this.framework.stage.getActiveStageSize();
        this.updateLayer(id, 'bottom', (info) => {
            return {
                x: 0,
                y: canvasHeight - info.height - info.top,
            };
        });
    }
}
